export const REGEX = {
  MULTIPLE_SPACES: /\s{2,}/,
};
